import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Flyer from "./pages/Flyer";
import "@/App.css";
import { setLenis } from "./lib/lenis";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { CostWorry } from "./components/site/CostWorry";
import { Discounts } from "./components/site/Discounts";
import { Program } from "./components/site/Program";
import { Stacker } from "./components/site/Stacker";
import { Faq } from "./components/site/Faq";
import { Footer } from "./components/site/Footer";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-asphalt font-body text-bone" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <CostWorry />
        <Program />
        <Discounts />
        <Stacker />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/flyer" element={<Flyer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
